import { useState, useRef, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import classNames from "classnames";
import { useNavigate } from "react-router-dom";

import { AppHeader } from "../../components/header/header";
import { LoadingIndicator } from "../../components/utilities/loader";
import { useAuth } from "../../services/authentication/authentication.context";
import { PillInputBox } from "../../components/forms/form-inputs";
import { AppAlert } from "../../components/utilities/app-alert";
import { faFilePdf } from "@fortawesome/free-solid-svg-icons";
import { useLesson } from "../../services/lessons/lessons.context";
import { AppFooter } from "../../components/footer/footer";

export const LessonAddPage = () => {

    const { isLoading, token } = useAuth();
    const { loading, createNewLesson, getAllCourses, createLessonEval } = useLesson();

    const [lessonData, setLessonData] = useState();
    const [vidPrev, setVidPrev] = useState();
    const [onAlert, setOnAlert] = useState();
    const [filePrev, setFilePrev] = useState();
    const [courses, setCourses] = useState([]);

    const clickRef = useRef();
    const fileRef = useRef();

    const navigateTo = useNavigate();

    const handleSetValue = (e) => {
        setLessonData((data) => ({
            ...data,
            [e.target.name]: e.target.value
        }))
    }

    const uploadVid = (e) => {
        if (e.target.files[0].type.split("/")[0] !== "video") {
            setOnAlert({
                caption: "Error!",
                message: "Invalid file format! Please upload a file of type video",
                accept: "Ok",
                onAccept: () => setOnAlert()
            })
            return;
        }
        setVidPrev(URL.createObjectURL(e.target.files[0]));
        setLessonData((d) => ({...d, videoFile: e.target.files[0]}));
    }


    const uploadFile = (e) => {
        if (e.target.files[0].type.split("/")[1].toLowerCase() !== "pdf") {
            setOnAlert({
                caption: "Error!",
                message: "Invalid file format! Please upload a file of type pdf",
                accept: "Ok",
                onAccept: () => setOnAlert()
            })
            return;
        }
        setFilePrev(e.target.files[0].name);
        setLessonData((d) => ({...d, documentFile: e.target.files[0]}));
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        const resp = await createNewLesson(lessonData, token);
        setOnAlert({
            caption: "Success!",
            message: resp.message,
            accept: "Ok",
            onAccept: async () => {
                setOnAlert();
                await createEvaluation(resp?.lesson);
            }
        })
    }

    /** create evaluation and navigate */
    const createEvaluation = async (lesson) => {
        try {
            const resp = await createLessonEval(lesson?._id, token);
            navigateTo("/createval",{state: {id: resp?.id}});
        } catch (error) {
            console.log({error});
            alert("Error creating eval");
        }
    }

    useEffect(() => {
        (async() => {
            const data = await getAllCourses();
            setCourses(data);
        })();
    },[])


    return (
        <div className="min-v">
            <AppHeader />
            {(isLoading || loading) && <LoadingIndicator />}
            {onAlert && (
                <AppAlert
                    caption={onAlert.caption}
                    message={onAlert.message}
                    accept={onAlert.accept}
                    onAccept={onAlert.onAccept}
                    closeAlert={() => setOnAlert()}
                />
            )}
            <div className="flx-cnt-pg">
                <div className={classNames("cap","lg-txt")}>Create a lesson</div>
                <div className="sm-sp" />
                <form className="add-form" onSubmit={(e) => handleSubmit(e)}>
                    <PillInputBox
                        type={"text"}
                        name={"title"}
                        caption={"Lesson title"}
                        onChange={(e) => handleSetValue(e) }
                    />
                    <PillInputBox
                        type={"number"}
                        name={"chapterNumber"}
                        caption={"Lesson number"}
                        onChange={(e) => handleSetValue(e) }
                    />
                    <div className="pill-input-box">
                        <select className="form-select"
                            name={'course'}
                            onChange={(e) => handleSetValue(e)}
                        >
                            <option value={null}  defaultValue={null}>{'Select the lesson course'}</option>
                            {courses?.map((c, indx) => (
                                <option value={c._id} key={indx}>{c.title}</option>
                            ))}
                        </select>
                    </div>
                    {vidPrev &&
                    <div className="video-prev-box">
                        <video src={vidPrev} width={250} />
                    </div>
                    }
                    <button 
                    className="sel-click"
                    onClick={(e) => {
                        e.preventDefault();
                        clickRef.current.click();
                    }}
                    >
                        Select a video for the lesson
                    </button>
                    <input 
                        type="file" 
                        name="avatar"  
                        onChange={(e) => uploadVid(e)}
                        className="file-sel"
                        ref={clickRef}
                    />
                    {filePrev && (
                        <div className="file-prev-nm">
                            <FontAwesomeIcon icon={faFilePdf} color="red" />
                            <span className="add-caption">{filePrev}</span>
                        </div>
                    )}
                    <button 
                        className="sel-click"
                        onClick={(e) => {
                            e.preventDefault();
                            fileRef.current.click();
                        }}
                    >
                        Select a pdf file for the lesson
                    </button>
                    <input 
                        type="file" 
                        name="avatar"  
                        onChange={(e) => uploadFile(e)}
                        className="file-sel"
                        ref={fileRef}
                    />
                    
                    <button 
                        className={classNames("form-button",'pill-input-box')}
                    >
                        Submit
                    </button>
                </form>
            </div>
            <AppFooter />
        </div>
    )
}